import { styled } from '@olxeu-jobs/ui';

export const Wrapper = styled('div', () => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

export const HintWrapper = styled('div', ({ $theme }) => ({
  margin: `${$theme.space[16]} auto`,
}));
